export const getDirection = () => {
    let direction = 'rtl'
    return {
      direction,
      isRtl: direction === 'rtl'
    }
  }